import { render, staticRenderFns } from "./AttendanceFixRadioForm.vue?vue&type=template&id=630e3107"
import script from "./AttendanceFixRadioForm.vue?vue&type=script&lang=ts"
export * from "./AttendanceFixRadioForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports